import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { 
    UserIcon, 
    EnvelopeIcon, 
    PhoneIcon, 
    BuildingOfficeIcon,
    PencilSquareIcon
} from '@heroicons/react/24/outline';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import axios from '../../axios';
import notify from '../../Utils/notify';

const Detail = () => {
    const { userId } = useParams();
    const [usuario, setUsuario] = useState({
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        sucursals_id: 0
    });
    const defaultImg = "/images/default-user.png";
    
    useEffect(() => {
        console.log("detalle");
        axios.get(`api/users/${userId}`)
            .then((res) => {
                console.log(res.data);
                setUsuario(res.data);
            })
            .catch(e => console.log("error", e));
    }, [userId]);

    const _updateImg = (file) => {
        console.log(file);
        const fData = new FormData();
        fData.append('id', usuario.id);
        fData.append("file", file);

        const loadingToast = notify.loading('Actualizando imagen...');
        axios.post('api/update-profile-image', fData)
            .then((resp) => {
                console.log("Response", resp);
                notify.dismiss(loadingToast);
                notify.success('Imagen actualizada correctamente');
                // Actualizar la imagen en el estado
                setUsuario({ ...usuario, image: resp.data.image });
            })
            .catch(e => {
                console.log("error", e);
                notify.dismiss(loadingToast);
                notify.error('Error al actualizar la imagen');
            });
    };
    
    return (
        <div>
            <div className="container-admin-menu">
                <Breadcrumb actual={usuario.name} />
            </div>
            <div className="container-admin-container">
                <div className="container-admin bg-white rounded-lg shadow-md">
                    <h5 className="p-5 text-xl font-bold text-gray-800">Detalle de usuario</h5>
                    
                    {/* Sección de perfil con imagen */}
                    <div className="px-5 pb-5">
                        <div className="w-full flex flex-col md:flex-row items-start gap-6 bg-gray-50 rounded-lg p-5 mb-6">
                            {/* Imagen de perfil */}
                            <div className="relative group">
                                <img 
                                    src={usuario.image ? usuario.image : defaultImg} 
                                    alt={usuario.name ? `Foto de perfil de ${usuario.name}` : "Foto de perfil"} 
                                    className="h-36 w-36 object-cover rounded-xl shadow-md"
                                />
                                <label className="absolute top-2 right-2 cursor-pointer p-2 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-200 hover:scale-110">
                                    <PencilSquareIcon className="h-5 w-5 text-[#5E72E4]" />
                                    <input 
                                        type="file"  
                                        className="hidden" 
                                        onChange={(e) => _updateImg(e.target.files[0])} 
                                        accept="image/png, image/gif, image/jpeg" 
                                    />
                                </label>
                            </div>
                            
                            {/* Información básica */}
                            <div className="flex-1 space-y-3">
                                <div className="flex items-center gap-2">
                                    <span className="text-sm font-medium text-gray-500">ID:</span>
                                    <span className="text-base font-semibold text-gray-800">{usuario.id}</span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className="text-sm font-medium text-gray-500">Fecha de creación:</span>
                                    <span className="text-base text-gray-700">
                                        {usuario.created_at && new Date(usuario.created_at).toLocaleDateString("es-MX", { 
                                            year: 'numeric', 
                                            month: 'long', 
                                            day: 'numeric' 
                                        })}
                                    </span>
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className="text-sm font-medium text-gray-500">Rol:</span>
                                    <span className="inline-flex items-center px-3 py-1 rounded-full bg-gradient-to-r from-[#0033ff] to-[#11cdef] text-white text-sm font-semibold shadow-sm">
                                        {usuario.rol && usuario.rol.name}
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        {/* Grid de información detallada */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                            {/* Nombre */}
                            <div className="flex flex-col gap-2">
                                <label className="text-sm font-medium text-gray-600">Nombre</label>
                                <div className="flex items-center gap-3 border border-gray-300 rounded-lg h-12 px-4 bg-[#11cdef]/20 hover:border-[#0033ff] transition-colors duration-200">
                                    <UserIcon className="h-6 w-6 text-blue-400" />
                                    <span className="text-gray-700">{usuario.name}</span>
                                </div>
                            </div>
                            
                            {/* Email */}
                            <div className="flex flex-col gap-2">
                                <label className="text-sm font-medium text-gray-600">Email</label>
                                <div className="flex items-center gap-3 border border-gray-300 rounded-lg h-12 px-4 bg-[#11cdef]/20 hover:border-[#0033ff] transition-colors duration-200">
                                    <EnvelopeIcon className="h-6 w-6 text-blue-400" />
                                    <span className="text-gray-700">{usuario.email}</span>
                                </div>
                            </div>
                            
                            {/* Teléfono */}
                            <div className="flex flex-col gap-2">
                                <label className="text-sm font-medium text-gray-600">Teléfono</label>
                                <div className="flex items-center gap-3 border border-gray-300 rounded-lg h-12 px-4 bg-[#11cdef]/20 hover:border-[#0033ff] transition-colors duration-200">
                                    <PhoneIcon className="h-6 w-6 text-blue-400" />
                                    <span className="text-gray-700">{usuario.phone}</span>
                                </div>
                            </div>
                            
                            {/* Sucursal */}
                            <div className="flex flex-col gap-2">
                                <label className="text-sm font-medium text-gray-600">Sucursal</label>
                                <div className="flex items-center gap-3 border border-gray-300 rounded-lg h-12 px-4 bg-[#11cdef]/20 hover:border-[#0033ff] transition-colors duration-200">
                                    <BuildingOfficeIcon className="h-6 w-6 text-blue-400" />
                                    <span className="text-gray-700">
                                        {(usuario.sucursal) ? usuario.sucursal.nombre_sucursal : 'Sin asignar'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Detail;